import type { UnitMode } from "~/feature/UnitMode/UnitMode";
import { makeFeaturesFilter } from "~/feature/UnitMode/unitLists";
import type { FeatureData } from "~/utils/models";

type Param = {
  label: string;
  value: string;
  converted: boolean;
};

const MAX_FEATURES = 3;

export function getFeaturesAsParams(features: FeatureData[], unitMode: UnitMode): Param[] {
  const byUnitMode = makeFeaturesFilter(unitMode);
  return features.filter(byUnitMode).slice(0, MAX_FEATURES).map(toParam);
}

function toParam(feature: FeatureData): Param {
  return {
    label: feature.name,
    value: [feature.values.join(", "), feature.unit].filter(Boolean).join(" "),
    converted: feature.isConverted,
  };
}
